import React from 'react';
import { NavLink } from 'react-router-dom';
import './index.css';

interface Link {
  id: string;
  title: string;
  navLink: string;
}

interface HorizontalNavBarProps {
  links: Link[];
}

const HorizontalNavBar: React.FC<HorizontalNavBarProps> = ({ links }) => {
  return (
    <div className="nav-bar">
      {links.map(link => (
        <NavLink 
          key={link.id} 
          to={link.navLink} 
          className={({ isActive }) => isActive ? 'active-nav-link' : 'nav-link'}
        >
          {link.title}
        </NavLink>
      ))}
    </div>
  );
};

export default HorizontalNavBar;
